

class PopularArticles {
    constructor(ajaxUrl) {
      this.ajaxUrl = ajaxUrl;
    }
  
    fetchPage() {
      var fetch = window.fetch;
      var requestUrl = this.ajaxUrl + '?action=theme:popular-articles-feed';
  
      var request = new window.Request(requestUrl);
  
      return fetch(request)
        .then(function(response) {
          if (response.status === 200) {
            return response.json();
          }
        })
        .then(this.fetchPageComplete);
    }
  
    fetchPageComplete(response) {
      return (response && response.data) ? response.data.articles : [];
    }
  
  }
  
  var popularArticles = new PopularArticles(window.SBM.ajaxUrl);
  
  
  export default popularArticles;
  
  